import React, { useEffect } from 'react';
import { UIStateProps, uiState } from '../../atoms/uiAtom';
import { notificationState, notificationStateUnreadItems } from '../../atoms/notificationAtom';
import { useRecoilValue, useSetRecoilState } from 'recoil';

import EmptyState from '../common/EmptyState';
import { ReactComponent as ImportantIcon } from '../../assets/important.svg';
import { Link } from 'react-router-dom';
import NotificationsList from './NotificationsList';
import { routes } from '../../routes';
import { useGetNotifications } from '../../hooks/notifications';
import { useTranslation } from 'react-i18next';

export default function NotificationsPanel() {
  const { t } = useTranslation();
  const notificationStateUnreadItemsAtom = useRecoilValue(notificationStateUnreadItems);
  const setNotificationState = useSetRecoilState(notificationState);
  const {
    data: notifications,
    isFetching: IsFetchingNotifications,
    isError: isErrorNotifications,
    refetch: refetchNotifications,
  } = useGetNotifications();

  useEffect(() => {
    refetchNotifications().then(() => {
      setNotificationState((prevState) => ({
        ...prevState,
        items: notifications?.data,
      }));
    });
  }, [notifications?.data, refetchNotifications, setNotificationState]);

  const setUiState = useSetRecoilState<UIStateProps>(uiState);

  useEffect(() => {
    setUiState((state) => ({
      ...state,
      isLoading: IsFetchingNotifications,
      hasError: isErrorNotifications,
    }));
  }, [IsFetchingNotifications, isErrorNotifications, setUiState]);

  return (
    <div className="notification-panel">
      <div className="notification-panel__content">
        <div className="notification-panel__header">
          <h2 className="notification-panel__header__title">{t('notifications')}</h2>
        </div>
        {notificationStateUnreadItemsAtom.items?.length === 0 ? (
          <EmptyState
            isSmall
            message={t('notifications.no.data')}
            icon={<ImportantIcon className="icon icon--medium" />}
          />
        ) : (
          <NotificationsList
            items={notificationStateUnreadItemsAtom.items?.slice(0, 2)}
            isLoading={isErrorNotifications || IsFetchingNotifications}
          />
        )}
      </div>
      <div className="notification-panel__footer" data-test-id="notification-panel-see-more">
        <Link to={routes.NOTIFICATIONS.path}>{t('common.see.more')}</Link>
      </div>
    </div>
  );
}
